import {
  AccountFieldsEnum,
  AppointmentFieldsEnum,
  ContactFieldsEnum,
  LeadFieldsEnum,
  OpportunityFieldsEnum,
  ProductFieldsEnum,
  ProjectFieldsEnum,
  QuoteFieldsEnum,
  TaskFieldsEnum
} from './fields';
import { EntityNameEnum } from '@ppl/graphql-space-api';

export const entityTypeFieldIdMap: {
  [K in EntityNameEnum]?: TaskFieldsEnum | AppointmentFieldsEnum | OpportunityFieldsEnum | ProjectFieldsEnum | ProductFieldsEnum | AccountFieldsEnum | ContactFieldsEnum | ProjectFieldsEnum | LeadFieldsEnum | QuoteFieldsEnum
} = {
  [EntityNameEnum.Task]: TaskFieldsEnum.ActivityTypeIdField,
  [EntityNameEnum.Appointment]: AppointmentFieldsEnum.ActivityTypeIdField,
  [EntityNameEnum.Opportunity]: OpportunityFieldsEnum.OpptyTypeIdField,
  [EntityNameEnum.Project]: ProjectFieldsEnum.ProjectTypeIdField,
  [EntityNameEnum.Product]: ProductFieldsEnum.ProductTypeIdField,
  [EntityNameEnum.Account]: AccountFieldsEnum.AccountTypeIdField,
  [EntityNameEnum.Contact]: ContactFieldsEnum.ContactTypeIdField,
  [EntityNameEnum.Lead]: LeadFieldsEnum.LeadTypeIdField,
  [EntityNameEnum.Quote]: QuoteFieldsEnum.QuoteTypeIdField
};

export const entityStepFieldIdMap: {
  [K in EntityNameEnum]?: LeadFieldsEnum | OpportunityFieldsEnum | QuoteFieldsEnum
} = {
  [EntityNameEnum.Opportunity]: OpportunityFieldsEnum.StepIdField,
  [EntityNameEnum.Lead]: LeadFieldsEnum.StepIdField,
  [EntityNameEnum.Quote]: QuoteFieldsEnum.StepIdField
};

